import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';

/**
 * 0020. ユーザ登録（Email検証・登録）
 * [PUT] /email_registrations/:email_registration_token
 */
type VerifyEmailRegistrationParams = {
  token: string;
  pin_code: string;
  invitation: string | null;
};
export const verifyEmailRegistration = (params: VerifyEmailRegistrationParams): Promise<any> => {
  return axios.put(`/api/email_registrations/${params.token}`, params);
};

export const useVerifyEmailRegistration = () => {
  return useMutation({
    mutationFn: verifyEmailRegistration,
  });
};
